import { ALLOW_NEARBY_IS_ACTIVE_DEFAULT } from '../constants';
import * as types from '../types';

function setAllowNearbyActive(state, action) {
    const {
        meta: filterId,
        payload: isActive,
    } = action;

    return {
        ...state,
        [filterId]: {
            ...state[filterId],
            allowNearby: isActive,
        },
    };
}

function resetAllowNearby(state, action) {
    const { meta: filterId } = action;

    return {
        ...state,
        [filterId]: {
            ...state[filterId],
            allowNearby: ALLOW_NEARBY_IS_ACTIVE_DEFAULT,
        },
    };
}

export default {
    [types.SET_ALLOW_NEARBY_ACTIVE]: setAllowNearbyActive,
    [types.RESET_ALLOW_NEARBY]: resetAllowNearby,
};
